import { Reveal } from "./Reveal";
import { ScreenshotFrame } from "./AppMockup";

const SHOWCASE = [
  {
    src: "/screenshots/dashboard.webp",
    alt: "Dashboard KalkuBisnis: ringkasan omzet bulan ini, untung bersih, produk terlaris, status balik modal, dan grafik tren omzet 14 hari",
    width: 1600,
    height: 777,
    caption: "Dashboard — ringkasan omzet, untung, dan status balik modal",
    wide: true,
  },
  {
    src: "/screenshots/kasir.webp",
    alt: "Kasir POS KalkuBisnis: pilih produk, keranjang belanja, hitung kembalian, dan riwayat transaksi terakhir",
    width: 1452,
    height: 1051,
    caption: "Kasir sederhana — catat penjualan dan hitung kembalian",
  },
  {
    src: "/screenshots/laporan.webp",
    alt: "Laporan dan analisis KalkuBisnis: total omzet, margin, tren harian, produk terlaris, dan tombol ekspor PDF",
    width: 1446,
    height: 1063,
    caption: "Laporan & analisis — lengkap dengan ekspor PDF",
  },
];

export function ProductIntro() {
  return (
    <section id="tentang" className="scroll-mt-20 bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div>
              <span className="inline-block rounded-full border border-teal-200/60 bg-teal-50 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-teal-700">
                Kenalan dulu
              </span>
              <h2 className="mt-4 text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
                Kenali Angka Usahamu dengan KalkuBisnis
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate-600 sm:text-lg">
                KalkuBisnis adalah aplikasi web yang membantu kamu menghitung dan mencatat hal-hal
                penting dalam usaha melalui satu tempat. Kamu bisa mulai dari perhitungan biaya dan
                harga jual, lalu menggunakan fitur pencatatan penjualan untuk membantu mengevaluasi
                usaha yang berjalan.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.15}>
            <ScreenshotFrame
              src="/screenshots/kalku-bep.webp"
              alt="Kalkulator BEP KalkuBisnis: hitung titik impas 250 unit per bulan, omzet BEP Rp3.750.000, grafik proyeksi BEP, dan estimasi laba"
              width={1419}
              height={1070}
              testid="intro-app-mockup"
              caption="Kalkulator BEP — tahu target penjualan minimum agar tidak rugi"
            />
          </Reveal>
        </div>
        <div className="mt-14 grid gap-8 md:grid-cols-2">
          {SHOWCASE.map((s, i) => (
            <Reveal key={s.src} delay={i * 0.1} className={s.wide ? "md:col-span-2" : ""}>
              <ScreenshotFrame
                src={s.src}
                alt={s.alt}
                width={s.width}
                height={s.height}
                caption={s.caption}
                testid={`showcase-${s.src.split("/").pop().replace(".webp", "")}`}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
